<template>
    <div class="flex flex-col text-white">
        <div class="flex justify-between items-center p-2">
            <div>
                <div class="font-bold">Name or Alias</div>
                <div v-if="name == '' " class="italic text-cool-gray">Anonymous</div>
                <div v-else>{{ name }}</div>
            </div>
            <donation-button @click="goToDonationDetails">Edit</donation-button>
        </div>
        <div class="flex justify-between items-center bg-black p-2">
            <div>
                <div class="font-bold">Donation Amount</div>
                <div>{{ formatMoney(amount) }}</div>
            </div>
            <donation-button @click="goToDonationDetails">Edit</donation-button>
        </div>
        <div class="flex justify-between items-center p-2">
            <div>
                <div class="font-bold">Comment</div>
                <div v-if="comment == '' " class="italic text-cool-gray">None entered</div>
                <div v-else>{{ comment }}</div>
            </div>
            <donation-button @click="goToDonationDetails">Edit</donation-button>
        </div>
        <div v-if="props.dtd" class="flex justify-between items-center p-2">
            <div>
                <div class="font-bold">Employer Matching</div>
                <div v-if="employer == '' " class="italic text-cool-gray">None entered</div>
                <div v-else>{{ employer }}</div>
            </div>
            <donation-button @click="goToDonationDetails">Edit</donation-button>
        </div>
        <div class="flex justify-between items-center bg-black p-2" v-if="props.characters">
            <div class="flex items-center gap-2">
                <img :src="`/character/${ character.filename }`" class="bg-light-gray rounded-lg w-12">
                <div>
                    <div class="font-bold">Overlay Character</div>
                    <div>{{ character.name }}</div>
                </div>
            </div>
            <donation-button @click="goToOverlayCharacter">Edit</donation-button>
        </div>
        <div class="flex justify-between items-center p-2 bg-black">
            <div>
                <div class="font-bold ">Incentives</div>
                <div v-if="!hasIncentives" class="italic text-cool-gray">None selected</div>
                <div v-if="fileDefinition && (fileSuggestion || customFilename)">{{ fileDefinition.name }} Filename: {{ filename }}</div>
                <div v-if="poll && pollItem">Poll: {{ poll.query }} - {{ pollItem.answer }}</div>
            </div>
            <donation-button @click="goToIncentiveSelection">Edit</donation-button>
        </div>
    </div>
</template>

<script setup>
import { inject, computed } from 'vue';
import { formatMoney } from '../../utils';
import DonationButton from './ui/Button.vue';

const props = defineProps({
    dtd: Boolean,
});

const name = inject('name');
const amount = inject('amount');
const comment = inject('comment');
const employer = inject('employer');
const employerFields = inject('employerFields');
const character = inject('character');
const poll = inject('poll');
const pollItem = inject('pollItem');
const fileDefinition = inject('fileDefinition');
const fileSuggestion = inject('fileSuggestion');
const customFilename = inject('customFilename');

const hasIncentives = computed(() => poll.value || pollItem.value || fileDefinition.value || fileSuggestion.value || customFilename.value);
const filename = computed(() => {
    if (fileSuggestion.value.id == -1) {
        return customFilename.value
    } else {
        return fileSuggestion.value.name
    }
})

const {
    goToDonationDetails,
    goToOverlayCharacter,
    goToIncentiveSelection
} = inject('navigation');
</script>
